import React from "react";
import FormTitle from "../../../components/FormTitle";
import CustomButton from "../../../components/AddButton";
import { Plus } from "../../../common/svg";
import { CargoProps } from "../../../service/interfaces/ApiResponse.interface";
import AddNewCargo from "./Components/AddNewCargo";
import { NewCargoFormValues } from "../../../service/interfaces/Forms";

const Cargo: React.FC<CargoProps & { watch: any }> = ({
  errors,
  register,
  setValue,
  clearErrors,
  cargoDetails,
  setCargoDetails,
  watch
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [cargoData, setCargoData] = React.useState<NewCargoFormValues[]>([]);

  // Get current selected cargo from form state
  const selectedCargo = watch("cargoDetails") || [];

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const toggleSelect = (cargo: any) => {
    // Normalize data to correct types
    const formatted = {
      cargoItem: cargo.cargoItem,
      cargoType: cargo.cargoType,
      weight: parseFloat(cargo.weight),
      volume: parseFloat(cargo.volume),
      count: parseInt(cargo.count),
      packageType: cargo.packageType,
      unit: "unit",
      isSelected: true,
    };

    const currentSelected = selectedCargo || [];
    const exists = currentSelected.find(
      (item: any) => item.cargoItem === formatted.cargoItem
    );

    let newSelectedCargo;
    if (exists) {
      newSelectedCargo = currentSelected.filter(
        (item: any) => item.cargoItem !== formatted.cargoItem
      );
    } else {
      newSelectedCargo = [...currentSelected, formatted];
    }

    setValue("cargoDetails", newSelectedCargo);

    if (newSelectedCargo.length > 0) {
      clearErrors("cargoDetails");
    }
  };

  // Helper function to check if a cargo item is selected
  const isCargoSelected = (cargo: any) => {
    return selectedCargo.some(
      (item: any) => item.cargoItem === cargo.cargoItem
    );
  };

  React.useEffect(() => {
    if (cargoDetails && cargoDetails.length > 0) {
      setCargoDetails(cargoDetails);
    }
  }, [cargoDetails, setCargoDetails]);

  return (
    <div className="bg-white rounded-[20px] p-2 px-6">
      <div className="flex items-center justify-between ">
        <FormTitle title="Cargo Details" />
        <CustomButton label="" onClick={toggleModal} icon={Plus} />
      </div>

      {cargoDetails.length > 0 ? (
        <table className="w-full table-auto">
          <thead>
            <tr>
              <th className="text-[14px] text-left px-2 py-1">Select Cargo</th>
              <th className="text-[14px] text-left px-2 py-1">Cargo Item</th>
              <th className="text-[14px] text-left px-2 py-1">Cargo Type</th>
              <th className="text-[14px] text-left px-2 py-1">Volume</th>
              <th className="text-[14px] text-left px-2 py-1">Weight</th>
              <th className="text-[14px] text-left px-2 py-1">Count</th>
              <th className="text-[14px] text-left px-2 py-1">Package Type</th>
            </tr>
          </thead>
          <tbody>
            {cargoDetails.map((cargo, index) => (
              <tr key={index} className="border-b border-dashed transition">
                <td className="text-left px-2 py-1">
                  <input
                    type="checkbox"
                    className="form-checkbox h-3 w-3 text-blue-600 ml-2"
                    checked={isCargoSelected(cargo)}
                    onChange={() => toggleSelect(cargo)}
                  />
                </td>
                <td className="text-[14px] text-left px-2 py-1">
                  {cargo.cargoItem}
                </td>
                <td className="text-[14px] text-left px-2 py-1">
                  {cargo.cargoType}
                </td>
                <td className="text-[14px] text-left px-2 py-1">
                  {cargo.volume + " " + cargo.volume_unit}
                </td>
                <td className="text-[14px] text-left px-2 py-1">
                  {cargo.weight + " " + cargo.weight_unit}
                </td>
                <td className="text-[14px] text-left px-2 py-1">
                  {cargo.count}
                </td>
                <td className="text-[14px] text-left px-2 py-1">
                  {cargo.packageType}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <>
          <p className="text-sm text-gray-500 italic px-2 py-2">
            No cargo found. Please create a cargo.
          </p>
        </>
      )}

      {errors.cargoDetails && errors.cargoDetails.message && (
        <p className="text-red-500 text-sm mt-2">
          {String(errors.cargoDetails.message)}
        </p>
      )}

      {isModalOpen && (
        <AddNewCargo
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setCargoData={setCargoDetails}
          cargoData={cargoDetails}
        />
      )}
    </div>
  );
};

export default Cargo;